import { useNavigate } from "react-router-dom";
import {
  getSectionGameImage,
  getSectionGameKey,
  getSectionGameNavigationPath,
  INT_CASINO_ROUTE,
  SectionGame,
  useHomeSectionGames,
} from "@hypexone/uicore";
import { PiPlayFill } from "react-icons/pi";
import { SVLS_API_CLIENT } from "../../App.utils";

const CASINO_LOBBY_SECTION_CODE = "casino_lobby";

const getProviderKey = (game: SectionGame) =>
  getSectionGameKey(game) ||
  `${game.sectionProvider || game.providerName}-${game.sectionCategory || game.category}`;

const ProvidersSection = () => {
  const navigate = useNavigate();
  const { games: casinoLobbyGames } = useHomeSectionGames(
    SVLS_API_CLIENT,
    CASINO_LOBBY_SECTION_CODE
  );

  const handleProviderClick = (game: SectionGame) => {
    const path = getSectionGameNavigationPath(
      game,
      INT_CASINO_ROUTE,
      "subProvider"
    );
    if (path) navigate(path);
  };

  return (
    <div className="grid grid-cols-3 pb-[1rem] md:mt-1  md:grid-cols-4 md:gap-1 gap-[1px] w-full">
      {casinoLobbyGames.map((game) => (
        <div
          key={getProviderKey(game)}
          className="w-full cursor-pointer"
          onClick={() => handleProviderClick(game)}
        >
          <img
            src={getSectionGameImage(game)}
            alt={game.sectionProvider || game.providerName || ""}
            className="w-full sm:h-[200px]"
          />
          <div className="hidden md:block">
            <div className=" w-full bg-black text-white text-sm flex items-center justify-between px-2 py-1 overflow-x-auto">
              <span className="whitespace-nowrap md:text-[12px]   text-[8px] font-[500]">
                {game.sectionProvider || game.providerName}
              </span>
              <div className="button-wrapper ">
                <button className="home-animated ">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                  Play Now
                  <PiPlayFill className="w-2 h-2 text-[darkred]" />
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProvidersSection;
